<template>
  <div class="row">
    <div class="col-12">
      <div class="text-center">
        <button class="btn btn-ss mb-4 w-100" @click="() => createFeedAction()">
          <span><i class="la la-rss" />Create {{ getFeedLabel(true) }}</span>
        </button>
        <button v-if="!isPodcaster()" class="btn btn-ss mb-4 w-100" @click="() => showModal('quick_start_item_create_modal')">
          <span><i class="la la-file-audio-o" />Create {{ getItemLabel() }}</span>
        </button>
        <button v-if="pending_uploads_count" class="btn btn-ss mb-4 w-100">
          <span><i class="la la-upload" />Review Pending Uploads ({{ pending_uploads_count }})</span>
        </button>

        <div v-if="has_incomplete_steps" class="row mb-4">
          <div class="col-4">
            <hr>
          </div>
          <div class="col-4 text-center">
            <strong>Finish Setup</strong>
          </div>
          <div class="col-4">
            <hr>
          </div>
        </div>
        <button v-if="!steps.has_themes" v-perms.disable="['api.custom-themes.store']"
                class="btn btn-ss mb-4 w-100"
                @click="redirectTo('/preferences#embed_themes')">
          <span><i class="la la-code-fork" />Create Embed Theme</span>
        </button>
        <button v-if="!steps.has_retention" v-perms.disable="['api.customer-retention.store']"
                class="btn btn-ss mb-4 w-100"
                @click="redirectTo('/preferences?accordion_id=manage_storage_retention_accordion_link#settings')">
          <span><i class="la la-clock-o" />Manage Retention Periods</span>
        </button>
      </div>
    </div>

    <vjs-modal name="quick_start_item_create_modal"
               :title="`Create ${getItemLabel(true)}`"
               icon="la la-plus-circle">
      <item-creation-form />
    </vjs-modal>

    <vjs-modal name="quick_start_feed_create_modal"
               :title="isPodcaster() ? 'Create Podcast' : 'Create Feed'"
               icon="la la-plus-circle">
      <div class="row">
        <div class="col-12 col-md-6 text-center">
          <a :href="isPodcaster() ? '/podcast/create' : '/feeds/create'" class="btn btn-ss w-100 mb-2"><i class="flaticon2-plus>" />Create New {{ getFeedLabel(true) }}</a><br>
          <p>Create a blank {{ getFeedLabel(true) }}</p>
        </div>
        <div class="col-12 col-md-6 text-center">
          <button class="btn btn-ss w-100 mb-2" @click="showImportModal">
            <i class="la la-download" />Import {{ isPodcaster() ? 'Podcast' : 'Feed' }}
          </button>
          <p>Create a {{ getFeedLabel(true) }} and import items using an existing RSS/XML Feed</p>
        </div>
      </div>
    </vjs-modal>
    <feed-url-modal />
  </div>
</template>

<script>

import VjsModal from "VueModals/VjsModal";
import ItemCreationForm from "VueComponents/ItemCreation/Form";
import FeedUrlModal from 'VuePartials/Feeds/FeedUrlModal';

export default {
  components: { ItemCreationForm, VjsModal, FeedUrlModal },
  data() {
    return {
      feed_importer_enabled: true,
      steps: {
        has_themes: true, // hide the button my default
        has_retention: true,
      },
      pending_uploads_count: 0,
    };
  },
  computed: {
    has_incomplete_steps() {
      let incomplete_steps = false;
      _.forEach(this.steps, (step) => {
        if (step === false) {
          incomplete_steps = true;
        }
      });

      return incomplete_steps;
    },
  },
  beforeMount() {
    this.feed_importer_enabled = this.permissionsCanAccessFeature('feed_importer')
      && this.permissionsCanDoAction('api.feed-importer.import');
  },
  mounted() {
    this.determineOutstandingSetup();
  },
  methods: {
    redirectTo(url) {
      window.location.href = url;
    },
    determineOutstandingSetup() {
      axios.get('/api/v1/custom-themes').then((response) => {
        this.steps.has_themes = !!response.data.data?.themes?.length;
      });
      if (this.permissionsCanAccessFeature('customer_retention')) {
        axios.get('/api/v1/customer-retention').then((response) => {
          this.steps.has_retention = !!response.data.data?.length;
        });
      }
      if (this.permissionsCanAccessFeature('third_party_uploader')) {
        axios.get('/api/v1/third-party-uploader?all_uploaders').then((response) => {
          const paginator = response.data.paginator;
          this.pending_uploads_count = paginator ? paginator.total : 0;
        });
      }
    },
    createFeedAction() {
      if (this.feed_importer_enabled) {
        this.showModal('quick_start_feed_create_modal');
      } else {
        window.location.href = "/feeds/create";
      }
    },
    async showModal(modal_name) {
      const result = await this.fireModal(modal_name);
      if (result.data.confirm) {
        this.$modal.hide('quick_start_modal');
      }
    },
    async showImportModal() {
      try {
        // Modal requesting feed path from user:
        const { url } = (await this.fireModal(`feed-url-modal`)).data;

        if (url) {
          // Fetch the feed data...
          axios.post("/api/v1/feed-importer/import", {
            url,
          }).then((response) => {
            const feed_import_uuid = response.data.data.uuid;
            toastr.success("Feed Import Initialised, Redirecting...");
            window.location.href = `/feed-importer/${feed_import_uuid}`;
          }).catch((error) => {
            window.handleAxiosError(error);
          });
        }

        this.$modal.hide('quick_start_modal');
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>
